export const getDisplayText = (transportMode: Mon.TransportMode, publicCode: string) => {
  // Split public code for some few cases of boat departures, where publicCode
  // for two quays are combined due to uncertainty of which will be used, e.g. AB => A/B
  if (transportMode === 'water' && typeof publicCode === 'string' && publicCode.length === 2) {
    return `${publicCode[0]}/${publicCode[1]}`;
  }
  return publicCode;
};
